import Applications from './Applications';
import ApplicationsManage from './ApplicationsManage/ApplicationsManage';
import ApplicationsEdit from './ApplicationsEdit/ApplicationsEdit';
import store from './applications.store';

const guard = (_, __, next) => {
  if (store.state.currentApplication && store.state.currentApplication.id) {
    return next();
  }

  next('/applications');
};

export default {
    path: '/applications',
    component: Applications,
    children: [
      {
        path: '',
        name: 'user.applications',
        component: ApplicationsManage,
      },
      {
        path: 'edit',
        name: 'user.applications.edit',
        component: ApplicationsEdit,
        beforeEnter: guard,
      },
    ],
  };